<template>
	<div class="card_block" @click="toDetails">
		<div class="start_layout">
			<div class="title">{{item.noticeTitle}}</div>
		</div>

		<!-- <div class="intro">
			<div class="text" v-html="item.noticeContent">
			</div>
		</div> -->
		<div class="bottom_area">
			<div><i class="el-icon-time icon"></i></div>
			<div style="margin-left: 5px;">{{item.createTime}}</div>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {}
		},
		props: ["item"],
		methods: {
			//跳转详情
			toDetails() {
				this.$router.push({
					path: "/collecting/details",
					query: {
						baseId: this.item.noticeId,
					}
				});
			}
		}
	}
</script>

<style lang="scss" scoped>
	.card_block {
		background: #FFFFFF;
		border-radius: 8px;
		padding: 22px;
		cursor: pointer;

		.title {
			overflow: hidden;
			text-overflow: ellipsis; //当对象内文本溢出时显示省略标记
			display: -webkit-box;
			-webkit-line-clamp: 1; //这边的2指的是两行
			-webkit-box-orient: vertical;
			font-size: 16px;
			color: #333333;
		}

		.intro {
			background: #F8F8F8;
			border-radius: 6px;
			padding: 14px;
			margin: 15px 0;

			.text {
				font-size: 14px;
				color: #999999;
				overflow: hidden;
				text-overflow: ellipsis; //当对象内文本溢出时显示省略标记
				display: -webkit-box;
				-webkit-line-clamp: 2; //这边的2指的是两行
				-webkit-box-orient: vertical;
			}
		}

		.bottom_area {
			display: flex;
			justify-content: start;
			align-items: start;
			font-size: 14px;
			color: #999999;
			margin-top: 10px;
		}
	}

	.card_block:hover {
		.title {
			color: #1395F3;
		}
	}
</style>